import { openBlock as o, createElementBlock as t, createElementVNode as e } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 18"
}, n = /* @__PURE__ */ e("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M11.808 16.41c3.486-.232 6.263-3.048 6.491-6.584.045-.691.045-1.408 0-2.1-.228-3.535-3.005-6.351-6.49-6.583a28 28 0 0 0-3.618 0C4.705 1.375 1.928 4.191 1.7 7.726a16.5 16.5 0 0 0 0 2.1c.083 1.288.652 2.48 1.323 3.487.389.705.132 1.584-.273 2.352-.293.555-.439.832-.322 1.032.118.2.38.206.904.219 1.037.025 1.736-.269 2.291-.678.315-.232.472-.348.58-.362.11-.013.323.075.75.25.383.159.829.256 1.238.283a28 28 0 0 0 3.617 0Z"
}, null, -1), s = /* @__PURE__ */ e("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "1.5",
  d: "M8.75 6.95c0-.708.56-1.282 1.25-1.282s1.25.574 1.25 1.282a1.3 1.3 0 0 1-.198.693C10.678 8.238 10 8.806 10 9.514v.32"
}, null, -1), c = /* @__PURE__ */ e("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.5",
  d: "M10 11.5h.008"
}, null, -1), l = [
  n,
  s,
  c
];
function d(i, a) {
  return o(), t("svg", r, [...l]);
}
const u = { render: d };
export {
  u as default,
  d as render
};
